<template>
  <Transition appear name="fade">
  <div class="main-container" id="main-container">
    <div class="image-container">
      
          <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="0"
            controls
            indicators
            fade
            background="#ababab"
            img-width="1024"
            img-height="420"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >

            <!-- Slides with img slot -->
            <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment --> 
            <b-carousel-slide v-for="i in this.amount" :key="i">
              <template v-slot:img>
                <img
                  id="image"
                  class="d-block img-fluid w-100"
                  width="1024"
                  height="420"
                  :src="getImageSrc(i)"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>

            <!-- Slide with blank fluid image to maintain slide aspect ratio -->
          </b-carousel>
    </div>
  </div>
</Transition>
</template>

<script>
export default {
  name: "CarouselComponent",
  props: {
    baseUrl: String,
    fileExtension: String,
    amount: Number
  },
  data() {
    return {
      slide: 0,
      sliding: null
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    getImageSrc(index) {
      return require("../../assets/images/" + this.baseUrl + "/image" + index + this.fileExtension);
    },
  },
};
</script>

<style scoped>
.main-container {
  height: 100%;
  width: 100%;
}

.image-container {
  border-radius: 20px;
}

</style>
